import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'おすすめ',
  bestPriceBadge: '最安値',
};
